import { render } from "./IconDropdownMenu.vue?vue&type=template&id=5aa9af04"
import script from "./IconDropdownMenu.vue?vue&type=script&lang=js"
export * from "./IconDropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__